import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditPage = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Page'
      fields={fields}
      apiPath={`admin/pages/${props.params.pageId}`}
      successRedirectPath='/write-now/pages'
      buildMenuItems={menuItems}
    />
  )
}

export default EditPage
